import userStore from '@/store/UserStore'
import { api } from '@/services/ApiService'
import Keycloak, { KeycloakError } from 'keycloak-js'

export default class KeycloakService {
  public async init() {
    const params = new URL(window.location.href).searchParams

    if (!params.get('token')) {
      if (userStore.realm || params.get('realm')) {
        const { url, clientId } = await api.fetchKeycloakConfiguration()

        if (!url || !clientId) {
          console.warn('Could not parse keycloak config')
          throw new Error('Could not parse keycloak config')
        } else {
          userStore.realm = params.get('realm') || userStore.realm
          userStore.token = await this.login(url, clientId) || ''
        }
      }
    } else {
      userStore.realm = ''
    }
  }

  private login(url: string, clientId: string): Promise<string | undefined> {
    const keycloak = new Keycloak({
      url: `${url}/auth`,
      realm: userStore.realm,
      clientId: clientId
    })

    return keycloak
      .init({
        onLoad: 'login-required',
        pkceMethod: 'S256',
        checkLoginIframe: false
      })
      .then(async (auth: boolean) => {
        if (!auth) {
          window.location.reload()
        } else {
          setInterval(
            () =>
              keycloak
                .updateToken(60)
                .then(() => (userStore.token = keycloak.token as string))
                .catch(error => console.error(`Failed to refresh the token, or the session has expired: ${error}`)),
            10000
          )
          return keycloak.token
        }
      })
      .catch((e: KeycloakError) => {
        throw Error('Authenticated Failed: ' + e.error + ' - ' + e.error_description)
      })
  }
}
